import request from "services/Request"
import { serializeVoices, serializeVoice } from "types/Voice"

export function getIdents(params) {
	return request({
		url: `/shop/idents`,
		method: 'GET',
		params
	}, serializeVoices)
}

export function getIdentByUrl(url: string) {
	return request({
		url: url.startsWith('/api/v2/shop/products/') ?
            url.replace('/api/v2/shop/products', '/shop/idents') :
            url.replace('/api/v2', ''),
		method: 'GET'
	}, serializeVoice)
}

export function getIdentByCode(code: string) {
	return request({
		url: `/shop/idents/${code}`,
		method: 'GET'
	}, serializeVoice)
}
